module.exports = __webpack_public_path__ + "media/src/pages/PreApplication/images/success-1-978d373a28dd2ee202ec7aecb75ad3d0.png";